import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { Icon, SwitchButton } from '@eti/components';
import { useTranslation } from '@eti/providers';

const wrapperStyles = css`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
`;

const labelStyles = css`
  color: ${etiColors.black};
  font-size: 0.875rem;
  font-weight: 400;
`;

const switchButtonWrapperStyles = css`
  margin-left: 6px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 6px;
  }
`;

const iconStyles = css`
  flex-shrink: 0;
  margin-right: 6px;

  [dir='rtl'] & {
    margin-left: 6px;
    margin-right: 0;
  }
`;

const ValidWithVoucherSwitch = ({ shouldShowValidWithVoucher, onShowValidWithVoucher }) => {
  const { t } = useTranslation();

  const handleChange = (e) => {
    const { checked } = e.target;
    onShowValidWithVoucher(checked);
  };

  return (
    <div className={wrapperStyles}>
      <Icon className={iconStyles} color={etiColors.confirmation.solid} id="tag" size="1rem" />
      <div className={labelStyles}>{t('Result.ValidWithVoucherSwitch.Label')}</div>
      <div className={switchButtonWrapperStyles}>
        <SwitchButton
          id="valid-with-voucher-switch"
          isChecked={shouldShowValidWithVoucher}
          onChange={handleChange}
          size="large"
        />
      </div>
    </div>
  );
};

ValidWithVoucherSwitch.propTypes = {
  onShowValidWithVoucher: PropTypes.func,
  shouldShowValidWithVoucher: PropTypes.bool,
};

export default ValidWithVoucherSwitch;
